import React from "react";
import { RefreshCw, Zap, Tag } from "lucide-react";

/**
 * 3 hairline-divider columns, muted ink icons.
 * Stacks vertically on mobile, 3 columns on tablet / desktop.
 * No boxes. No colored tiles. No Vela purple. Region-neutral copy.
 */
export function BenefitsRow() {
  return (
    <div className="flex flex-col md:grid md:grid-cols-3 border-t border-b border-lineSoft py-0 md:py-4 mb-7">
      <div className="py-3.5 md:py-0 md:px-5 border-b md:border-b-0 md:border-r border-lineSoft md:first:pl-0">
        <div className="inline-flex items-center gap-1.5 mb-1">
          <RefreshCw size={14} strokeWidth={2} className="text-ink3" />
          <p className="text-[12.5px] font-bold text-ink">Auto-sync nightly</p>
        </div>
        <p className="text-[11.5px] text-ink3 leading-snug">
          Transactions pulled every night. No CSVs, no manual entry.
        </p>
      </div>
      <div className="py-3.5 md:py-0 md:px-5 border-b md:border-b-0 md:border-r border-lineSoft">
        <div className="inline-flex items-center gap-1.5 mb-1">
          <Zap size={14} strokeWidth={2} className="text-ink3" />
          <p className="text-[12.5px] font-bold text-ink">Cleaned + matched</p>
        </div>
        <p className="text-[11.5px] text-ink3 leading-snug">
          Cryptic bank descriptions become readable payee names, matched to the right invoice or payroll run.
        </p>
      </div>
      <div className="py-3.5 md:py-0 md:px-5 md:last:pr-0">
        <div className="inline-flex items-center gap-1.5 mb-1">
          <Tag size={14} strokeWidth={2} className="text-ink3" />
          <p className="text-[12.5px] font-bold text-ink">Auto-categorized</p>
        </div>
        <p className="text-[11.5px] text-ink3 leading-snug">
          By type: income, expense, payroll. You review what the system isn't sure about.
        </p>
      </div>
    </div>
  );
}